var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8692_54624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.682 23.9999C6.18004 23.9999 6.51959 23.7354 7.1308 23.172L10.1642 20.4122H15.484C18.2684 20.4122 19.7285 18.8829 19.7285 16.1001V9.4078C19.7285 6.62507 18.2684 5.0957 15.484 5.0957H4.24453C1.46013 5.0957 0 6.62507 0 9.4078V16.1001C0 18.8829 1.46013 20.4122 4.24453 20.4122H4.57277V22.7005C4.57277 23.4939 4.96893 23.9999 5.682 23.9999ZM6.1008 22.1141V19.5268C6.1008 18.9634 5.89707 18.7564 5.34244 18.7564H4.24453C2.4222 18.7564 1.6299 17.871 1.6299 16.1001V9.4078C1.6299 7.64847 2.4222 6.76305 4.24453 6.76305H15.484C17.3063 6.76305 18.0987 7.64847 18.0987 9.4078V16.1001C18.0987 17.871 17.3063 18.7564 15.484 18.7564H10.0737C9.53038 18.7564 9.24741 18.8369 8.88521 19.2279L6.1008 22.1141Z",
    fill: "#575F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7602 14.5134L13.8881 13.582L23.3733 3.92291C24.2108 3.07201 24.2108 1.71512 23.3619 0.864219L23.1129 0.611226C22.2979 -0.228182 20.9509 -0.193682 20.1247 0.657241L10.6509 10.2818L9.68884 12.3286C9.08894 13.628 10.4359 15.0883 11.7602 14.5134Z",
    fill: "#575F67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2285 13.2483L13.1074 12.4318L21.0304 4.39411L19.6835 3.04873L11.7831 11.0865L10.9229 12.9148C10.8436 13.0873 11.0474 13.3172 11.2285 13.2483ZM21.721 3.68119L22.3999 2.96824C22.7171 2.63478 22.7171 2.15182 22.3999 1.84134L22.151 1.58837C21.8682 1.2894 21.3814 1.3239 21.087 1.63436L20.3853 2.3243L21.721 3.68119Z",
    fill: "#575F67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8692_54624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/new-chat.84bdff16fb254631347ec596b7da2c73.svg";
export { ForwardRef as ReactComponent };